<template>
  <v-container fluid fill-height justify-center id="scrolling-techniques-7" class="overflow-y-auto" key="changepass">
    <transition name="router-anim" mode="out-in">
      <v-row v-if="success" key="1" class="max-w">
        <v-col>
          <div class="display-1 font-weight-medium mb-3">
            {{ $t('sukces') }}
          </div>
          <div class="font-weight-light mb-4 c-lighter-1">
            {{ $t('zmiana-sukces') }}
          </div>
          <v-btn rounded large class="w-btn mb-3 t-empty" to="/dashboard">{{ $t('go-home') }}</v-btn>
        </v-col>
      </v-row>
      <v-row px-4 v-else key="2" class="max-w">
        <v-col>
          <v-form
            ref="form"
            v-model="valid"
            class="mx-5"
          >
            <div class="display-1 font-weight-medium mb-6">
              {{ $t('zmiana-hasla') }}
            </div>

            <v-text-field
            v-model="passwordOld"
            :counter="8"
            :rules="passwordRules"
            :label="$t('haslo-old')"
            required
            type="password"></v-text-field>

            <v-text-field
            v-model="password"
            :counter="8"
            :rules="passwordRules"
            :label="$t('Nowe haslo')"
            required
            type="password"></v-text-field>

            <v-text-field
            v-model="password2"
            :counter="8"
            :rules="password2Rules"
            :label="$t('haslo-powt')"
            required
            type="password"></v-text-field>

            <div class="mt-8 text-center">
                <v-btn 
                  :loading="saving"
                  :disabled="saving" 
                  @click="postForm"
                  x-large class="mx-1 mb-1" color="primary">{{ $t('zmien-haslo') }}</v-btn>

                <v-btn text x-large to="/settings" class="mx-1 mb-1">
                  Anuluj
                </v-btn>
            </div>
          </v-form>
        </v-col>
      </v-row>
    </transition>
  </v-container>
</template>

<script>
  import { mapGetters } from 'vuex'
  export default {
    data: () => ({
      valid: true,
      passwordOld: '',
      password: '',
      passwordRules: [
        v => !!v || 'Wypełnij hasło',
        v => (v && v.length >= 6) || 'Hasło musi mieć minimum 6 znaków'
      ],
      password2: '',
      password2Rules: [
        v => !!v || 'Wypełnij hasło',
        //v => (v && v.length >= 6) || 'Hasło musi mieć minimum 6 znaków'
      ],
      saving: false,
      snackbar: false,
      snackbarText: '',
      snackbarColor: "error",
      success: false
    }),
    computed: {
      ...mapGetters([
        'token'
      ])
    },
    methods: {
      validate () {
        if (this.$refs.form.validate()) {
          this.snackbar = true
        }
      },
      resetValidation () {
        this.$refs.form.resetValidation()
      },
      postForm () {
        const formData = new URLSearchParams();
        formData.append('passwordOld', this.passwordOld);
        formData.append('password', this.password);
        formData.append('password2', this.password2);
        formData.append('token', this.token);

        this.$store.dispatch('changepass', formData)
        .then(res => {
          this.saving = false;
          if (res.error) {
            this.$store.commit("alert", {
              color: "error",
              text: res.error.code
            });
          } else {
            this.success = true;
          }
        });
      }
    }
  }
</script>

<style>
</style>

